import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/home/Home.vue';
import Edit from '@/components/edit/EditInit.vue';
import Cal from '@/components/cal/CalInit.vue';
import Conf from '@/components/config/Config.vue';
import Doc from '@/components/confirm/Doc.vue';
import RelMng from '@/components/relmng/RelInit.vue';
import Neta from '@/components/neta/Neta.vue';
import Media from '@/components/media/MediaInit.vue';
import Login from '@/components/common/Login.vue';
import Device from '@/components/device/Device.vue';
import SendMng from '@/components/sendmng/SendMng.vue';
Vue.use(Router);

const routes = [
  {
    path: '/',
    component: Home,
  },
  {
    path: '/list',
    name : 'List',
    component: RelMng,
  },
  {
    path: '/sendmng',
    name : 'SendMng',
    component: SendMng,
	props : true,
  },
  {
    name : 'Edit',
    path: '/edit',
    component: Edit,
	props : true,
  },
  {
    path: '/cal',
    name : 'Cal',
    component: Cal,
  },
  {
    path: '/neta',
    name : 'Neta',
    component: Neta,
  },
  {
    path: '/confirm',
    name : 'confirm',
    component: Doc,
  },
  {
    path: '/login',
    name : 'login',
    component: Login,
  },
  {
    path: '/config',
    name : 'config',
    component: Conf,
  },
  {
    path: '/media',
    name : 'media',
    component: Media,
  },
  {
    path: '/device',
    name : 'device',
    component: Device,
  },

]


export default new Router({
	base : '/rel/',
    mode: 'history',
    routes,
    scrollBehavior () {
        return new Promise((resolve) => {
           setTimeout(() => {
             resolve({ x: 0, y: 0 })
           }, 500)
        })
    },
});

